import __base_store from '@/store/__base_store'

/**
 * Store de países de exportación (modelo `pais_exportacion`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'pais_exportacion',
	},
})

